
const digest = 'ccf3a61dd245344a08c682716de38cc61d43aaac7f3e217b7d1b2ca2da1366fa';
const classes = {"wrapper":"_wrapper_1ccd5_1","input":"_input_1ccd5_6","suffix":"_suffix_1ccd5_39","prefix":"_prefix_1ccd5_49","withPrefix":"_withPrefix_1ccd5_59","withSuffix":"_withSuffix_1ccd5_65","errorMessage":"_errorMessage_1ccd5_71","invalid":"_invalid_1ccd5_77"};
const css = `._wrapper_1ccd5_1 {
  position: relative;
  display: flex;
}

._input_1ccd5_6 {
  width: -webkit-fill-available;
  min-height: 55px;
  font-family: Poppins, sans-serif;
  font-size: 14px;
  font-weight: 400;
  padding: 16px 20px;
  color: #000;
  flex: 1;
  border: 1px solid #c1cbe4 !important;
  border-radius: 15px;
  box-shadow: inset 0 3px 0 0 rgba(198, 214, 240, 0.5);
  background-color: #dce7fa;
  position: relative;
}
._input_1ccd5_6:disabled {
  background-color: #f3f3f3;
  opacity: 1;
}
._input_1ccd5_6:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  background-color: #dce7fa;
  color: #000;
}
._input_1ccd5_6[type=number]::-webkit-outer-spin-button, ._input_1ccd5_6[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
._input_1ccd5_6[type=number] {
  -moz-appearance: textfield;
}

._suffix_1ccd5_39 {
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #3C3F9C;
  right: 25px;
  bottom: 17px;
  z-index: 10;
}

._prefix_1ccd5_49 {
  left: 20px;
  font-family: Poppins, sans-serif;
  position: absolute;
  font-size: 14px;
  color: #3C3F9C;
  bottom: 17px;
  z-index: 10;
}

._withPrefix_1ccd5_59 {
  padding-left: 50px !important;
  border-top-left-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
}

._withSuffix_1ccd5_65 {
  padding-right: 50px !important;
  border-top-right-radius: 15px !important;
  border-bottom-right-radius: 15px !important;
}

._errorMessage_1ccd5_71 {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: #d81616;
}

._invalid_1ccd5_77 {
  border-color: #d81616 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23dc3545' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23dc3545' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
  background-repeat: no-repeat;
  background-position: center right calc(0.375em + 0.1875rem);
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  